(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!matchMedia('(hover: hover)').matches) return;
  document.querySelectorAll('.card').forEach((card) => {
    const video = card.querySelector('[data-card-video]');
    if (!video) return;
    card.addEventListener('mouseenter', () => {
      video.play().then(() => video.classList.add('is-ready')).catch(() => {});
    });
    card.addEventListener('mouseleave', () => {
      video.classList.remove('is-ready'); video.pause(); video.currentTime = 0;
    });
  });
})();
